import React, { useContext } from "react";
import styled from "styled-components";
import { mobile } from "../Responsive";
import { ThemeContext } from "../context";

const PBrowser = styled.div`
  height: 20px;
  background-color: ${(props) =>
    props.dark ? "#495057" : "rgb(243, 242, 242)"};
  display: flex;
  align-items: center;
  position: sticky;
  z-index: 2;
`;
const PCircle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin: 3px;
  background-color: ${(props) => (props.dark ? "#ced4da" : "#fff")};
`;
const Link = styled.a``;
const PImg = styled.img`
  width: 100%;
  transition: all 10s ease;
`;
const P = styled.div`
  width: 40%;
  max-width: 500px;
  height: 35vh;
  margin: 20px 10px;
  border: 3px solid
    ${(props) => (props.dark ? "#495057" : "rgb(243, 242, 242)")};
  border-radius: 5px;
  overflow: hidden;

  &:hover ${PImg} {
    transform: translateY(-100%);
  }

  ${mobile({ width: "100%", height: "30vh" })}
`;

const Product = ({ img, link }) => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <P dark={darkMode}>
      <PBrowser dark={darkMode}>
        <PCircle dark={darkMode}></PCircle>
        <PCircle dark={darkMode}></PCircle>
        <PCircle dark={darkMode}></PCircle>
      </PBrowser>
      <Link href={link} target="_blank" rel="noreferrer">
        <PImg src={img} alt="" />
      </Link>
    </P>
  );
};

export default Product;
